import QueryString from 'utils/query_string'
import WebsiteConfigs from 'website_configs/website_configs'

const COOKIE_CATEGORY = 'marketing'
const SESSION_UTM_PARAMS_KEY = 'utm_params'
const UTM_MEDIUM_KEY = 'utm_medium'

class UtmTracker {
  static saveUtmParams () {
    if (WebsiteConfigs.displayCookiesConsent && window.orejime && window.orejime.internals.manager.consents[COOKIE_CATEGORY] !== true) {
      return
    }

    const utmParams = QueryString.parseUtmParams(window.location.search)

    if (Object.entries(utmParams).length) {
      sessionStorage.setItem(SESSION_UTM_PARAMS_KEY, JSON.stringify(utmParams))
    }
  }

  static getUtmMedium () {
    return this.getUtmParams()[UTM_MEDIUM_KEY]
  }

  static getUtmParams () {
    return JSON.parse(sessionStorage.getItem('utm_params') || '{}')
  }
}

export default UtmTracker
